export default "__VITE_ASSET__BrxyM5ge__"